export const FileExtensionEnum = {
    PDF: "PDF",
    DOCX: "DOCX",
};